// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppleSignin_wrapper__wG_4o","disabled":"AppleSignin_disabled__ijPyd","logo":"AppleSignin_logo__mftCj","appleSignin":"AppleSignin_appleSignin__Qhwiu"};